import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import LoadingScreen from "./components/LoadingScreen";
import CustomCursor from "./components/CustomCursor";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ProductsList from "./pages/ProductsList";
import ProductPage from "./pages/ProductPage";
import ProjectsPage from "./pages/ProjectsPage";
import DealerPage from "./pages/DealerPage";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import ContactPage from "./pages/ContactPage";
import FloatingWhatsAppButton from "./components/FloatingWhatsAppButton";
import SiteNoticePopup from "./components/SiteNoticePopup";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Show the cinematic loading screen ONCE per browser session, and only on the homepage.
// Inner pages and subsequent navigations load instantly.
function InitialLoader() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    const seen = sessionStorage.getItem("liftile_intro_seen");
    return pathname === "/" && !seen;
  });

  useEffect(() => {
    if (show) {
      try { sessionStorage.setItem("liftile_intro_seen", "1"); } catch (e) { /* sessionStorage unavailable (privacy mode) */ }
    }
  }, [show]);

  if (!show) return null;
  return <LoadingScreen onDone={() => setShow(false)} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <InitialLoader />
        <CustomCursor />
        <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#1E1E20", border: "1px solid #FF6B1A40", color: "#F5F1EA" } }} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductsList />} />
          <Route path="/products/:slug" element={<ProductPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/dealer" element={<DealerPage />} />
          <Route path="/insights" element={<BlogList />} />
          <Route path="/insights/:slug" element={<BlogPost />} />
          {/* Legacy /blog routes redirect-by-render to keep old links + SEO working */}
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <FloatingWhatsAppButton />
        <SiteNoticePopup />
      </BrowserRouter>
    </div>
  );
}

export default App;
